import { capitalize, startCase } from 'lodash-es';
import { Maybe } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalize', pure: false, standalone: true })
export class CapitalizePipe implements PipeTransform {
  public transform(value: Maybe<string>): string {
    return value ? capitalize(startCase(value)) : '';
  }
}
